import { TextProps } from "../../types/textTypes";
import "./h3.scss";

const H3: React.FC<TextProps> = ({ children, className }) => {
  return <h3 className={`h3 ${className ? className : ""}`}>{children}</h3>;
};

export default H3;
